//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Data from '../data'
import wxAPI from '@/utils/wx_api'
import Service from '@/service'
import check from '@/common/utils/check'

import toggleRule from '../_togglr_rule'

const SELECT_TYPE = {
    SINGLE: 0,
    MULTIPLE: 1
}

const TAG_TRANSFORM = {
    '没有看过': '非实看用户',
    '实地看过': '实看用户'
}

export default {
    data () {
        return {
            name: '',
            content: '',
            focus: true,
            sending: false,
            title: '',
            questions: [
                {
                    question: '您实地看过房吗？',
                    select_type: SELECT_TYPE.SINGLE,
                    selected: '',
                    tags: [
                        '没有看过',
                        '实地看过'
                    ]
                },
                {
                    question: '选择您的评论类型',
                    select_type: SELECT_TYPE.MULTIPLE,
                    selected: [],
                    tags: [
                        '楼盘咨询',
                        '户型点评',
                        '周边配套'
                    ]
                }
            ],
            img_count: 1,
            photos_urls: [],
            img_uploading: false
        }
    },
    created () {
        const { name } = this.$route.query
        this.name = name
        this.title = `${name}`
    },
    methods: {
        changeContent ({ target }) {
            this.content = target.value
        },
        selectTag (i, tag) {
            const item = this.questions[i]
            if (item.select_type === SELECT_TYPE.SINGLE) {
                item.selected = item.selected === tag ? '' : tag
            } else {
                const selected_index = item.selected.indexOf(tag)
                if (selected_index > -1) {
                    item.selected.splice(selected_index, 1)
                } else {
                    item.selected.push(tag)
                }
            }
        },
        onComment () {
            if (this.sending) {
                return
            }
            this.sending = true
            const content = this.content.trim()
            if (content === '' && !this.photos_urls.length) {
                this.sending = false
                this.$wx.showToast({
                    title: '您还未填写评论内容',
                    icon: 'none'
                })
                return
            }
            this.submit(content)
        },
        async onChooseImage() {
            try {
                const [path] = await wxAPI.chooseImage({
                    count: 1,
                    sizeType: ['compressed'],
                    sourceType: ['album', 'camera'],
                    is_upload: true
                })
                this.img_uploading = true
                const url = await wxAPI.uploadImg(path)
                this.photos_urls = [url]
                this.img_uploading = false
            } catch (error) {
                console.error(error)
                this.img_uploading = false
            }
        },
        previewImg(e) {
            const current = this.photos_urls[0]
            this.$wx.previewImage({
                current,
                urls: this.photos_urls
            })
        },
        onRmImg() {
            this.$wx.showToast({
                title: '提示',
                content: '确定要删除?',
                success: res => {
                    if (res.confirm) {
                        this.photos_urls = []
                    }
                }
            })
        },
        submit (content) {
            const { building_id, name } = this.$route.query
            const tag_list = this.questions.reduce((rs, item) => {
                if (item.select_type === SELECT_TYPE.SINGLE) {
                    if (item.selected) {
                        rs.push(TAG_TRANSFORM[item.selected] || item.selected)
                    }
                } else {
                    const temp = item.selected.map(tag => TAG_TRANSFORM[tag] || tag)
                    rs.push(...temp)
                }
                return rs
            }, [])
            const params = {
                content
            }
            if (tag_list.length) {
                params.tag_list = tag_list
            }
            if (this.photos_urls.length) {
                params.photos_urls = this.photos_urls
            }
            Service.postBuildingComment(building_id, params).then((data) => {
                this.sending = false
                if (!data) {
                    return
                }
                Data.create_comment = true
                this.$router.back()
            }).catch(() => {
                this.sending = false
            })
        }
    },
    components: {
        toggleRule
    },
}
